import router from '@/apps/router'
import { getToken, removeToken } from '@/shared/utils'
import { useOrganizationModules, useUser } from '@/shared/composables'
import { authApi, userApi } from '@/shared/api'

const whiteList = [
  'AuthPage',
  'PasswordRecoveryPage',
  'NewPasswordPage',
  'ClinicChoicePage',
]

const { organizationModules } = useOrganizationModules()

router.beforeEach(async (to, from, next): Promise<{ name: string }> => {
  if (to.path.includes('/organizations')) {
    if (
      to.query.mode === from.query.mode ||
      (from.path.includes('/organizations') &&
        to.name === 'AllOrganizationsPage' &&
        from.query.mode === 'archive')
    ) {
      next()
    }

    if (from.query.mode === 'archive') {
      next({ name: to.name, params: to.params, query: from.query })
    }
  }

  const { user, isAuth, setUser, setIsAuth } = useUser()

  if (from.name === 'ClinicChoicePage' && to.name === 'AuthPage') {
    removeToken()
  }

  const token = getToken()

  if (!isAuth.value && token) {
    const [error, response] = await userApi.getInfoAboutMe()

    if (error && to.name === 'ClinicChoicePage') {
      next()
    } else if (error) {
      removeToken()
      next({
        name: 'AuthPage',
        query: { redirect: to.fullPath as string },
      })
    } else if (to.name !== 'ClinicChoicePage') {
      setUser(response.data)
      setIsAuth(true)
      await authApi.getOrganizationModules(response.data.organization.id)

      const isCloseModule =
        (organizationModules.value.indexOf('brushmap') <= -1 &&
          to.name === 'BrushMapPage') ||
        (organizationModules.value.indexOf('periodontology') <= -1 &&
          to.name === 'PeriodontalPage') ||
        (organizationModules.value.indexOf('screening') <= -1 &&
          to.name === 'ScreeningReportPage')

      if (isCloseModule && to.params.reportId === '0') {
        return { name: 'PatientListingPage' }
      }
      if (
        organizationModules.value.indexOf('plaque') <= -1 &&
        to.name === 'ReportCreationPage'
      ) {
        return { name: 'PatientListingPage' }
      }
    }
  }

  if (isAuth.value && token) {
    if (!user.value.organization) {
      removeToken()

      next({ name: 'AuthPage', query: { redirect: to.fullPath as string } })
    }

    if (to.name === 'AuthPage' || to.name === 'ClinicChoicePage') {
      if (user.value.role === 'admin') {
        next({ name: 'UserListingPage' })
      }

      next({ name: 'PatientListingPage' })
    } else {
      next()
    }
  } else {
    setIsAuth(false)

    if (whiteList.includes(to.name as string)) {
      next()
    } else {
      next({ name: 'AuthPage', query: { redirect: to.fullPath as string } })
    }
  }
})
